import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import StateCheckboxSelector from "@/components/shared/StateCheckboxSelector";
import { BTN_BLACK, INPUT, errText } from "@/components/pageSettings/AdminModal";
import { CriteriaRules } from "./CriteriaRules";
import { Field, StepShell, setupUrl } from "./StepShell";

export function CriteriaStep({ state, orgId, onSaved, carry }) {
  const [states, setStates] = useState(state.states.length ? state.states : carry.prefill?.states || []);
  const [price, setPrice] = useState(state.price ?? "");
  const [crit, setCrit] = useState(state.criteria || {});
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setCrit((c) => {
    const n = { ...c };
    if (v === null || v === "" || (Array.isArray(v) && !v.length)) delete n[k];
    else n[k] = v;
    return n;
  });
  const save = async () => {
    if (!states.length) { toast.error("Pick at least one state"); return; }
    if (!(Number(price) > 0)) { toast.error("Enter a price per lead"); return; }
    setBusy(true);
    try {
      const { data } = await api.put(`${setupUrl(orgId)}/criteria`, { states, price_per_lead: Number(price), intake_criteria: crit });
      toast.success("Lead criteria saved");
      onSaved(data, "pages");
    } catch (e) {
      toast.error(errText(e, "Couldn't save the criteria"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <StepShell title="Lead criteria" testId="setup-step-criteria"
               hint="Which leads this buyer takes. A lead that doesn't match goes to the next matching buyer."
               footer={<button type="button" className={BTN_BLACK} onClick={save} disabled={busy} data-testid="setup-criteria-save">{busy ? "Saving…" : "Save & continue"}</button>}>
      <div>
        <div className="label-mono mb-1">States they take *</div>
        <StateCheckboxSelector value={states} onChange={setStates} testId="setup-states" />
      </div>
      <div className="max-w-xs">
        <Field label="Price per lead (USD) *">
          <input type="number" min="1" step="1" className={INPUT} value={price} onChange={(e) => setPrice(e.target.value)} data-testid="setup-price" />
        </Field>
      </div>
      <CriteriaRules crit={crit} set={set} />
      <Link to={`/clients/${orgId}/manage`} className="text-xs underline inline-block" data-testid="setup-criteria-more">
        ZIP codes, counties and caps are on Manage buyer
      </Link>
    </StepShell>
  );
}
